import React from "react";
import { MdClose } from "react-icons/md";
import Button from "@components/ui/Button";
import SuccessIcon from "@assets/icons/success.svg";
import ErrorIcon from "@assets/icons/error.svg";
import InfoIcon from "@assets/icons/info.svg";
import { IoReturnDownBack } from "react-icons/io5";

export type ModalType = "success" | "error" | "info" | "warning" | "confirm";

interface ModalProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  type?: ModalType;
  showConfirmation?: boolean;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  title = "Modal Title",
  description = "This is a modal description.",
  type = "info",
  showConfirmation = false,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return <img src={SuccessIcon} alt="icon" />;
      case "error":
        return <img src={ErrorIcon} alt="icon" />;
      case "warning":
        return <img src={InfoIcon} alt="icon" />;
      case "confirm":
        return <img src={InfoIcon} alt="icon" />;
      default:
        return <img src={InfoIcon} alt="icon" />;
    }
  };

  return (
    <div className="modal-overlay show">
      <div className="modal-container">
        {showConfirmation && (
          <div className="modal-close" onClick={onClose}>
            <MdClose />
          </div>
        )}

        <div className="modal-icon">{getIcon()}</div>

        <div className="modal-title">{title}</div>
        <div className="modal-desc">{description}</div>

        <div className="modal-actions">
          {showConfirmation ? (
            <>
              <Button
                type="button"
                text={cancelText}
                variant="outline"
                onClick={onClose}
              />
              <Button
                type="submit"
                text={confirmText}
                variant="primary"
                onClick={onConfirm}
              />
            </>
          ) : (
            <button className="cancel-button" onClick={onClose}>
              <IoReturnDownBack /> Okay
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
